const generateMenuFAQ = () => {
  const CHAPTER_SELECTOR = '[data-chapter]';
  const MAIN_FAQ_SELECTOR = '.main-faq';
  const CONTAINER_MENU = '.main-faq__menu';
  const INPUT_TYPE = 'radio';
  const INPUT_CLASS_PREFIX = 'chapter-toggle';
  const LABEL_CLASS_PREFIX = 'chapter-label';
  const LABEL_NAME_PREFIX = 'menu-faq';

  function setupFAQVisibilityControls() {
    const chapters = document.querySelectorAll(CHAPTER_SELECTOR);
    const mainFaqContainer = document.querySelector(MAIN_FAQ_SELECTOR);
    const menuContainer = document.querySelector(CONTAINER_MENU);

    if (!chapters || !mainFaqContainer || !menuContainer) {
      return
    }

    const styleElement = document.createElement('style');
    let dynamicCSS = '';

    chapters.forEach((chapterSection, index) => {
      const chapterData = chapterSection.dataset.chapter;
      const chapterId = chapterSection.dataset.key;

      const inputId = `${chapterId}`;

      const inputElement = document.createElement('input');
      inputElement.type = INPUT_TYPE;
      inputElement.id = inputId;
      inputElement.name = LABEL_NAME_PREFIX;
      inputElement.className = INPUT_CLASS_PREFIX;

      mainFaqContainer.prepend(inputElement);

      const labelElement = document.createElement('label');
      labelElement.textContent = chapterData;
      labelElement.setAttribute('for', inputId);
      labelElement.className = LABEL_CLASS_PREFIX;

      menuContainer.appendChild(labelElement);

      dynamicCSS += `
      #${inputId}:checked ~ section .main-faq__menu .${LABEL_CLASS_PREFIX}[for='${inputId}'] {
        color: #111111;
        opacity: 1;
      }
      #${inputId}:checked ~ .main-faq__conteiner section[data-key='${inputId}'] {
        display: block;
        position: relative;
        z-index: 3;
      }
    `;

      if (index === 0) {
        inputElement.checked = true;
      }
    });

    styleElement.textContent = dynamicCSS;
    mainFaqContainer.appendChild(styleElement);
  }

  setupFAQVisibilityControls();
}

const movimentCardFAQ = () => {
  const MAIN_FAQ_SELECTOR = '.main-faq';
  const CARD_SELECTOR = '.main-faq__card';
  let cardCopied = false;

  const mainFaq = document.querySelector(MAIN_FAQ_SELECTOR);
  const originalCard = document.querySelector(CARD_SELECTOR);

  if (!mainFaq || !originalCard) {
    return;
  }

  if (!cardCopied) {
    const clonedCard = originalCard.cloneNode(true);
    mainFaq.appendChild(clonedCard);
    cardCopied = true;
  }
}

export { generateMenuFAQ, movimentCardFAQ }